import { ComplexEntityTypes } from "../../../../utils/constants";
import { ReactComponent as AppEntityType } from "../icons/asset_icon/Assets_App_24.svg";
import { ReactComponent as DataStoreEntityType } from "../icons/asset_icon/Assets_Database_24.svg";
import { ReactComponent as HostEntityType } from "../icons/asset_icon/Assets_Host_24.svg";
import { ReactComponent as NonhumanIdentityEntityType } from "../icons/asset_icon/Assets_Non_human_identity_24.svg";
import { ReactComponent as ServerEntityType } from "../icons/asset_icon/Assets_Server_24.svg";
import { ReactComponent as UserEntityType } from "../icons/asset_icon/Assets_User_24.svg";

export const EntityTypeInfo = {
  [ComplexEntityTypes.HOST]: { title: "Endpoint", icon: HostEntityType },
  [ComplexEntityTypes.USER]: { title: "User", icon: UserEntityType },
  [ComplexEntityTypes.SERVER]: { title: "Server", icon: ServerEntityType },
  [ComplexEntityTypes.DATA_STORE]: {
    title: "Datastore",
    icon: DataStoreEntityType,
  },
  [ComplexEntityTypes.NONHUMAN_IDENTITY]: {
    title: "NHI",
    icon: NonhumanIdentityEntityType,
  },
  [ComplexEntityTypes.APP]: {
    title: "Application",
    icon: AppEntityType,
  },
};

export const RDS_ENTITIES_QUERY_KEY_PREFIX = "rds-entities";
